import React, {useState} from 'react';
import {Form, Formik} from "formik";
import {SchemaDevisForm} from "../../../../../../../schemas/commercial/SchemaDevisForm";
import {initialValuesDevis} from "../../../../../../../config/InitialValues/InitialValuesDevis";
import FormDevisInformationClient from "./FormDevisInformationClient";
import FormDevisMeetState from "./FormDevisMeetState";
import FormDevisProjectInformations from "./FormDevisProjectInformations";
import FormPriceCurrentDevis from "./FormPriceCurrentDevis";
import FormDevisButtons from "./FormDevisButtons";
import FormDevisArch from "./FormDevisArch";
import FormPartenershipRequest from "./FormPartenershipRequest";
import FormOptionalContract from "./FormOptionalContract";
import {toast} from "react-toastify";
import QuotesService from "../../../../../../../services/QuotesService";

const FormDevis = ({setShowPopUp, update, setUpdate, project, requestArchForm, isLoading, requestProject}) => {

	const [currentQuote, setCurrentQuote] = useState(0);

	const onSubmit = async (values, action) => {
		delete values.optionalContract
		/*Clone avec les bonnes values a envoyé a l'API*/
		let valuesToPush = JSON.parse(JSON.stringify(values));

		if (valuesToPush.client.billingAddress.postcode === "") {
			delete valuesToPush.client.billingAddress.postcode
		}
		if (valuesToPush.address.postcode === "") {
			delete valuesToPush.client.billingAddress.postcode
		}

		if (valuesToPush.client.phone === "") {
			delete valuesToPush.client.phone
		}

		if (valuesToPush.visit === "Visite a prendre avec les ingénieurs") {
			valuesToPush.visit = null
		}

		if (valuesToPush.archIri === "N/A") {
			valuesToPush.archIri = null
		}

		valuesToPush.quotes.map((itemQuote) => {
			itemQuote.orders.map((itemOrder) => {
				if (itemOrder.idService) {
					itemOrder.serviceIri = `/api/services/${itemOrder.idService}`
				}
				itemOrder.price = parseFloat(itemOrder.price);
				itemOrder.spent = parseFloat(itemOrder.spent);
				itemOrder.margin = parseFloat(itemOrder.margin);
				for (const key in itemOrder) {
					if (Object.prototype.hasOwnProperty.call(itemOrder, key)) {
						/* Vérifier les keys autorisées dans le back */
						if (!["price", "id", "quantity", "serviceIri", "title", "description", "discount", "margin", "spent"].includes(key)){
							delete itemOrder[key];
						}
					}
				}
			})
		})

		toast.info("Enregistrement du devis en cours...")

		const request = await QuotesService.patchQuotes(project.id, valuesToPush)
		if (request.request.status === 200 && valuesToPush.sendOnSubmit) {
			toast.success("Le devis a bien été envoyé au client")
			requestProject()
			window.location.reload()
		} else if (request.request.status === 200 && !valuesToPush.sendOnSubmit) {
			toast.success("Le devis a bien été enregistré")
			requestProject()
			window.location.reload()
		} else {
			requestProject()
			toast.error("Une erreur est survenue lors de l'enregistrement du devis")
		}
	}

	return (

		<Formik enableReinitialize={true} initialValues={initialValuesDevis} validationSchema={SchemaDevisForm}
		        onSubmit={onSubmit}>
			<Form className={"form-devis"}>
				<div className={"form-devis-container"}>
					<FormDevisInformationClient project={project}/>
					<div className={"form-devis-row"}>
						<FormDevisMeetState project={project}/>
						<FormDevisArch project={project} requestArchForm={requestArchForm} setShowPopUp={setShowPopUp}/>
					</div>
					<FormDevisProjectInformations isLoading={isLoading} project={project} setUpdate={setUpdate} update={update}
					                              setCurrentQuote={setCurrentQuote} currentQuote={currentQuote}/>
					<FormPriceCurrentDevis currentQuote={currentQuote} update={update}/>
					<FormPartenershipRequest project={project} setUpdate={setUpdate} update={update}/>
					<FormOptionalContract/>
				</div>
				<FormDevisButtons project={project} setUpdate={setUpdate} update={update}/>
			</Form>
		</Formik>
	);
};


export default FormDevis;
